import { useParams } from 'react-router-dom';

import { MilesTable } from 'components';

import { useGetRequest } from 'hooks';

import { DashboardEligibleOffers } from 'codegen';

import { columns } from './lib';

export const EligibleOffers = () => {
  const { snapId } = useParams();

  const { data, loading } = useGetRequest<DashboardEligibleOffers>({
    url: `/snaps/${snapId}/eligible-offers`,
    options: {
      refreshDeps: [snapId],
    },
  });

  return (
    <MilesTable
      horizontalScroll
      id='eligible-snap-offers'
      size='small'
      title='Eligible Offers'
      rowKey='id'
      loading={loading}
      columns={columns}
      dataSource={data?.eligibleOffers}
    />
  );
};
